import Axios from 'axios';
import router from '../../router';

const state = {
    roles: [],
    permissions: []
};

const getters = {
    hasPermission: state => permission => {
        console.log('state.permissions:', state.permissions);
        return state.permissions.includes(permission);
    },
    hasRole: state => role => {
        return state.roles.includes(role);
    },
    getPermissions: state => state.permissions
};

const actions = {
    async loadUserRolesAndPermissions({ commit, dispatch }) {
        try {
            const response = await Axios.get('user-roles');
            console.log('response.data:', response.data);
            commit('setRoles', response.data.role);
            commit('setPermissions', response.data.permissions);
        } catch (error) {
            console.error('Failed to load user roles and permissions:', error);
            return dispatch('auth/logout', null, { root: true });
        }
    }
};

const mutations = {
    setRoles(state, roles) {
        state.roles = roles;
    },
    setPermissions(state, permissions) {
        state.permissions = permissions;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
